import React from 'react'

function ML_program_details() {
  return (
    <div>
    {/* ----------------------Mobile View---------------- */}
    <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>Mastering Machine Magic</h1>
                    <p className='py-2'>Dive into the world of Machine Learning! Unravel the secrets of algorithms and data with our expert-led courses. Enrol now for a brighter, tech-fueled future!’</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>With our course, take a thorough exploration of the field of machine learning. Explore both supervised and unsupervised learning by starting with the fundamentals of Python and moving on to more complex algorithms like Linear Regression and Random Forests. Discover the wonders of Natural Language Processing, become an expert in Neural Networks, and use well-known libraries to implement ideas practically. Finish it off with real-world projects that will enable you to become an expert practitioner and successfully traverse the fascinating field of machine learning. Join us to improve your abilities!</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>Machine Learning</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    {/* ----------------------Desktop View---------------- */}
    <div className='d-none d-md-block'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-8 detail_1stcomp_img'>
                <div className='pt-3 Program_details_1stcomp_text'>
                    <h1 className='display-6'>Mastering Machine Magic</h1>
                    <p className='py-4'>Dive into the world of Machine Learning! Unravel the secrets of algorithms and data with our expert-led courses. Enrol now for a brighter, tech-fueled future!’</p>
                </div>
                <div className='mt-3 Program_details_1stcomp_text'>
                    <h1 className='display-3'>Overview</h1>
                    <p className='py-4'>With our course, take a thorough exploration of the field of machine learning. Explore both supervised and unsupervised learning by starting with the fundamentals of Python and moving on to more complex algorithms like Linear Regression and Random Forests. Discover the wonders of Natural Language Processing, become an expert in Neural Networks, and use well-known libraries to implement ideas practically. Finish it off with real-world projects that will enable you to become an expert practitioner and successfully traverse the fascinating field of machine learning. Join us to improve your abilities!</p>
                </div>
            </div>
            <div className='col-md-4'>
                <div>
                <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Machine Learning</h1>
                  <div className='Details_text '>
                    <ul className='pt-4'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default ML_program_details
